import { render } from "./PR17-102022.vue?vue&type=template&id=ef9a2ff6"
import script from "./PR17-102022.vue?vue&type=script&lang=js"
export * from "./PR17-102022.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__